import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  author: "Robert Miller",
  quote: "Emanuel Construction Group delivered our commercial roofing project ahead of schedule and with unmatched precision.",
  position: "Property Manager",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660819/img/client_robert_miller.png"
}, {
  author: "Sarah Jenkins",
  quote: "The remodeling team transformed our kitchen into a masterpiece. Their attention to detail is truly industrial-grade.",
  position: "Homeowner",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660819/img/client_sarah_jenkins.png"
}];
export default function EsperienzeDegliAllievi() {
  return;
}